import { cn } from '../lib/cn'

export type StatusTone = 'ok' | 'warn' | 'error' | 'idle'

const toneClasses: Record<StatusTone, string> = {
  ok: 'bg-emerald-500',
  warn: 'bg-amber-500',
  error: 'bg-red-500',
  idle: 'bg-muted-foreground/40',
}

export interface StatusDotProps {
  tone: StatusTone
  label: string
  className?: string
}

/**
 * Colour alone never carries the meaning — the label is always rendered for
 * screen readers even when the caller hides it visually.
 */
export function StatusDot({ tone, label, className }: StatusDotProps) {
  return (
    <span className={cn('inline-flex items-center gap-2', className)}>
      <span aria-hidden className={cn('size-2 rounded-full', toneClasses[tone])} />
      <span className="text-sm">{label}</span>
    </span>
  )
}
